import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';

import { postRequest } from '~services';
import { BaseFilterOption } from '~types';

type UseSearchOptionsWithNone = {
  path: string;
  queryKey: string[];
  bodyRequest?: object;
};

/**
 * Hook that adds "None" option to the beginning of search results
 */
export const useSearchOptionsWithNone = ({
  path,
  queryKey,
  bodyRequest,
}: UseSearchOptionsWithNone) => {
  const [search, setSearch] = useState<string>('');

  const onSearch = (searchString: string) => {
    setSearch(searchString);
  };

  const data = useQuery([...queryKey, search, bodyRequest], () =>
    postRequest({
      path,
      data: { page: 0, size: 20, name: search, ...bodyRequest },
    }),
  );

  const noneOption: BaseFilterOption = { id: '', name: 'None' };
  const apiOptions = data.data?.data?.data || [];
  const options = [noneOption, ...apiOptions];

  return {
    onSearch,
    options,
  };
};
